import { Container, CssBaseline, Grid, Link } from "@mui/material";
import { useState } from "react";
import ModalLoadingFull from "../utils/ModalLoadingFull";
import SignIn from "./SignIn";
import Copyright from "./components/Copyright";
import SignUp from "./SignUp";
import Verify from "./Verify";
import ForgotPassword from "./ForgotPassword";
import VerifyForgotPassword from "./VerifyForgotPassword";

const initialFormState = {
  username: "",
  password: "",
  email: "",
  confirmationCode: "",
};

export default function Form(params) {
  const [processing, setProcessing] = useState(false);
  const [formType, updateFormType] = useState(params?.formType || "signIn");
  const [formState, updateFormState] = useState(initialFormState);

  function renderForm() {
    switch (formType) {
      case "signUp":
        return (
          <SignUp
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
            updateFormType={updateFormType}
          />
        );
      case "verify":
        return (
          <Verify
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
            updateFormType={updateFormType}
          />
        );
      case "signIn":
        return (
          <SignIn
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
          />
        );
      case "forgotPassword":
        return (
          <ForgotPassword
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
            updateFormType={updateFormType}
          />
        );
      case "forgotPasswordSubmit":
        return (
          <VerifyForgotPassword
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
            updateFormType={updateFormType}
          />
        );
      default:
        return null;
    }
  }

  return (
    <>
      <Container component="main" maxWidth="sm" sx={{ pl: [2, 0], pr: [2, 0] }}>
        <CssBaseline />

        {renderForm()}
        <Grid container spacing={2} sx={{ mt: 4 }}>
          {formType !== "signIn" && (
            <Grid item xs={12}>
              Already have an account?{" "}
              <Link
                href={`/login${window.location.search || ""}`}
                onClick={() => updateFormType("signIn")}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Sign In
              </Link>
            </Grid>
          )}
          {formType !== "signUp" && (
            <Grid item xs={12}>
              Need an account?{" "}
              <Link
                href={`/signup${window.location.search || ""}`}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Sign Up
              </Link>
            </Grid>
          )}
          {formType !== "verify" && (
            <Grid item xs={12}>
              Need to{" "}
              <Link
                href={`/verify${window.location.search || ""}`}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Verify
              </Link>{" "}
              account?
            </Grid>
          )}
          {formType !== "forgotPassword" &&
            formType !== "forgotPasswordSubmit" && (
              <Grid item xs={12}>
                Forget your password?{" "}
                <Link href={`/forgotpassword${window.location.search || ""}`}>
                  Reset Password
                </Link>
              </Grid>
            )}
        </Grid>

        <Copyright sx={{ mt: 4, mb: 4 }} />
      </Container>

      {processing && <ModalLoadingFull />}
    </>
  );
}
